import api from "./api";

class TasksManager {
    tasks(config?: any) {
        return api.get(`/tasks`, config)
    }

    deleteAll(config?: any) {
        return api.delete(`/delete_my_tasks`, config)
    }

    paginatedList = this.tasks
}

const tasksManager = new TasksManager()

export default tasksManager
